import React from "react";
import "./ThinkingAnimation.css";

const ThinkingAnimation = () => {
  return (
    <div className="thinking-animation-container">
      <div className="thinking-bubble">
        <div className="bubble">
          <div className="dots">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
        </div>
      </div>
      <div className="thinking-text" style={{color: 'white'}}>Luna is thinking...</div>
    </div>
  );
};

export default ThinkingAnimation;
 